import React from 'react';

import { Container, Footer, GlobalError } from '@bessemercws/components';
import { useApolloWrapperContext } from '@bessemercws/graphql';
import { useClientContext } from '@bessemercws/providers';
import { Outlet } from 'react-router-dom';

import Header from '#/components/Header';
import NewUserWizard from '#/components/VerificationWizard/VerificationWizard';
import { useSetClientIdFromPath } from '#/layouts/hooks/useSetClientIdFromPath';
import { WithHeaderContainer } from './WithHeader.styles';

export const WithHeader = () => {
  useSetClientIdFromPath();
  const { client } = useApolloWrapperContext();
  const { viewerErrorCode, handleViewerError } = useClientContext();

  document.title = import.meta.env.VITE_TITLE;

  function handleOnRefresh() {
    handleViewerError(null);
    client.reFetchObservableQueries();
  }

  return (
    <WithHeaderContainer data-testid="with-header">
      <Header className="header" />
      <Container maxWidth="xl" disableGutters>
        <div className="main">
          {viewerErrorCode ? (
            <GlobalError errorCode={viewerErrorCode} onRefresh={handleOnRefresh} isClientWebsiteError={true} />
          ) : (
            <Outlet />
          )}
        </div>
      </Container>
      <NewUserWizard />
      <Footer className="footer" data-testid="footer-container" />
    </WithHeaderContainer>
  );
};
